import { Button, Center, Icon, SimpleGrid } from '@chakra-ui/react';
import Page from '@inspire/ui/chakra/layout/Page';

import { NewsCategories } from '@inspire/data/static/news';
import Spinner from '@inspire/ui/chakra/Spinner';

import Layout from 'components/layout/Layout';
import ArticleItem from 'components/article/ArticleItem';
import { useInfiniteArticles, useMyProfile } from 'lib/hooks';
import ResponsiveTabs from 'components/layout/ResponsiveTabs';
import { actualitesPath } from 'lib/paths';
import { ChevronDownIcon } from '@inspire/ui/icons';

const tabs = [{ label: 'Tout', value: '' }].concat(NewsCategories);

const ActualitesPage = () => {
  const {
    articles,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
  } = useInfiniteArticles();
  useMyProfile(); // to trigger lastDayOfActivity update

  return (
    <Page title={'Derniers articles'} headingIsTitle>
      <ResponsiveTabs
        tabs={tabs}
        getPath={actualitesPath}
        mobileThreshold={700}
      />

      {isFetching && !isFetchingNextPage ? (
        <Center>
          <Spinner size="xl" thickness="4px" mt={12} />
        </Center>
      ) : (
        <>
          <SimpleGrid columns={{ sm: 1, md: 2, lg: 3 }} spacing="30px" mt={8}>
            {articles?.map((article, j) => (
              <ArticleItem key={j} article={article} />
            ))}
          </SimpleGrid>

          {(hasNextPage || isFetchingNextPage) && (
            <Center mt={4}>
              <Button onClick={() => fetchNextPage()}>
                <Icon as={isFetchingNextPage ? Spinner : ChevronDownIcon} />
              </Button>
            </Center>
          )}
        </>
      )}
    </Page>
  );
};

ActualitesPage.getWrappers = (page) => (
  <Layout variant="adaptative" rowVariant="gray" containerWidth="lg">
    {page}
  </Layout>
);

export default ActualitesPage;
